/**
 * Home API — List live home cards for the current user.
 *
 * GET /v1/home
 *
 * Returns the currently-valid in-app home cards for the requesting school-user:
 * a live DB read over ContentRecord (presentationStyle = HOME_CARD), filtered by
 * publish/expiry window and audience match, minus the reader's dismissals. No
 * Stream feed is involved. Clients render what's returned without re-checking
 * timestamps or audience.
 */

import { z } from 'zod'

import { HomeCardViewSchema } from '../../schemas/entities/home-card'

export const ListHomeCardsResponseSchema = z.object({
  cards: z.array(HomeCardViewSchema),
  /** Count of non-dismissed matching cards — feeds the Updates/Announcements chip. */
  unreadCount: z.number().int().nonnegative()
})

export type ListHomeCardsResponse = z.infer<typeof ListHomeCardsResponseSchema>
